import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=44103cab&scoped=true&"
var script = {}
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=44103cab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44103cab",
  null
  
)

export default component.exports